import { useSetAtom } from 'jotai';

import { useTranslate } from '@growtherapy/i18n';
import { Button, Text } from '@growtherapy/sprout-ui';

import { VisitorDrawerState, preSessionVibesOpenAtom, visitorDrawerStateAtom } from '../../state';
import { useBackgroundMusicPlayback } from '../background-action/useBackgroundMusicPlayback';

export function ReflectionTopicsCta({
  openPreSessionVibes,
  openReflectionTopicsDrawer,
}: {
  openPreSessionVibes: () => void;
  openReflectionTopicsDrawer: () => void;
}) {
  const t = useTranslate();
  return (
    <>
      <Text data-testid='pre-session-prompt-reflection-topics' className='font-medium'>
        {t('telehealth-core:waitingRoom.inTheMeantimeTakeAMomentTo')}
      </Text>
      <Button className='flex gap-4 justify-center items-center w-full' onClick={openReflectionTopicsDrawer}>
        {t('telehealth-core:waitingRoom.reviewTopicsForTodaysSession')}
      </Button>
      <Button onClick={openPreSessionVibes} use='link'>
        {t('telehealth-core:waitingRoom.orUnwindWhileYouWait')}
      </Button>
    </>
  );
}

export function ReflectionTopicsCtaWrapper() {
  const setPreSessionVibesOpen = useSetAtom(preSessionVibesOpenAtom);
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const { handlePlay } = useBackgroundMusicPlayback();
  const openPreSessionVibes = () => {
    setDrawerState(null);
    setPreSessionVibesOpen(true);
    handlePlay();
  };
  const openReflectionTopicsDrawer = () => {
    setDrawerState(VisitorDrawerState.REFLECTION_TOPICS);
  };
  return (
    <ReflectionTopicsCta
      openPreSessionVibes={openPreSessionVibes}
      openReflectionTopicsDrawer={openReflectionTopicsDrawer}
    />
  );
}
